__turbopack_context__.v({
  "brandNav": "ArticleLayout-module__asgd3a__brandNav",
});
